import type { DataSource } from '@/src/io/import/dataSource';
import { sourcesIncludeVolumeLoad } from '@/src/io/import/isVolumeLoad';
import { requestReplaceScanConfirm } from '@/src/io/import/replaceScanIntent';
import {
  hasLoadedScan,
  resetViewerForNewScan,
} from '@/src/actions/viewerReset';

/**
 * When a new scan would replace existing data, ask the user and reset the
 * viewer on confirmation. Returns false if the user cancels.
 */
export async function prepareForVolumeLoad(
  sources: DataSource[]
): Promise<boolean> {
  if (!hasLoadedScan() || !sourcesIncludeVolumeLoad(sources)) {
    return true;
  }

  const confirmed = await requestReplaceScanConfirm();
  if (!confirmed) {
    return false;
  }

  resetViewerForNewScan();
  return true;
}

/**
 * NIfTI volume imports resolve intent inside {@link importSingleFile}. When
 * the user chooses Volume while a scan is already loaded, confirm and reset
 * before registering the new image.
 */
export async function prepareForNiftiVolumeImport(): Promise<boolean> {
  if (!hasLoadedScan()) {
    return true;
  }

  const confirmed = await requestReplaceScanConfirm();
  if (!confirmed) {
    return false;
  }

  resetViewerForNewScan();
  return true;
}
